var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.userList.favoriteAmount ? _c('DataEntityList', {
    attrs: {
      "get": _vm.$api.favorite.get,
      "params": Object.assign({}, _vm.params, {
        products: _vm.favoriteIds
      }),
      "watch-param-changes": ""
    },
    on: {
      "success": _vm.onSuccess
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            pageCount = _ref.pageCount,
            pageCurrent = _ref.pageCurrent,
            loadMore = _ref.loadMore,
            changePage = _ref.changePage,
            sortList = _ref.sortList,
            activeSort = _ref.activeSort,
            sort = _ref.sort,
            itemsCount = _ref.itemsCount;
        return [loading && _vm.initialLoad ? _c('StatusBlock', {
          attrs: {
            "size": "l",
            "type": "loading"
          }
        }) : error ? _c('StatusBlock', {
          attrs: {
            "size": "l",
            "type": "error"
          }
        }) : [_vm.productList && _vm.productList.length ? _c('div', {
          staticClass: "favorite-page"
        }, [_c('div', {
          ref: "products",
          staticClass: "favorite-page__header"
        }, [_c('h1', {
          staticClass: "favorite-page__title h1 pr-7"
        }, [_vm._v("\n          Избранные товары\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "p grey-text mr-10"
        }, [_vm._v("\n          " + _vm._s(_vm.declOfNumGoods) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "favorite-page__header-delete",
          on: {
            "click": function ($event) {
              _vm.modalActive = true;
            }
          }
        }, [_c('div', {
          staticClass: "favorite-page__header-delete-icon"
        }), _vm._v(" "), _c('span', {
          staticClass: "favorite-page__header-delete-text"
        }, [_vm._v("Очистить избранное")])])]), _vm._v(" "), _c('TSProductGrid', {
          attrs: {
            "quantity-on-page": 30,
            "loading": loading,
            "product-list": _vm.productList,
            "pagination": {
              count: pageCount,
              current: pageCurrent,
              itemQuantity: itemsCount
            },
            "link-page": _vm.linkPage,
            "sort-list": sortList,
            "list-name": "Избранное",
            "mobile-favorite-button": ""
          },
          on: {
            "change-page": function ($event) {
              changePage($event), _vm.changeQueryParamsPage(Number($event)), _vm.scrollTop();
            },
            "load-more": function ($event) {
              loadMore(), _vm.changeQueryParamsPage($event);
            },
            "remove-favorite": function ($event) {
              return _vm.onRemoveFavorite($event, _vm.productList);
            },
            "product-select": function ($event) {
              return _vm.emitter.emit('product-select', {
                index: $event.index,
                product: $event.product,
                listName: 'Избранное'
              });
            }
          },
          scopedSlots: _vm._u([{
            key: "headerDesktopFilter",
            fn: function () {
              return [_c('div', {
                staticClass: "favorite-page__product-grid-header"
              }, [_c('Sort', {
                attrs: {
                  "list": sortList,
                  "value": activeSort
                },
                on: {
                  "sort": function ($event) {
                    sort($event), _vm.onSort($event);
                  }
                }
              }), _vm._v(" "), _c('div', {
                staticClass: "favorite-page__product-grid-delete",
                on: {
                  "click": function ($event) {
                    _vm.modalActive = true;
                  }
                }
              }, [_c('div', {
                staticClass: "favorite-page__product-grid-delete-icon"
              }), _vm._v(" "), _c('span', {
                staticClass: "favorite-page__product-grid-delete-text"
              }, [_vm._v("Очистить избранное")])])], 1)];
            },
            proxy: true
          }, {
            key: "headerMobileFilter",
            fn: function () {
              return [_c('SortSelect', {
                attrs: {
                  "list": sortList,
                  "value": activeSort
                },
                on: {
                  "change": function ($event) {
                    sort($event), _vm.onSort($event);
                  }
                }
              })];
            },
            proxy: true
          }], null, false, 1952457090)
        }), _vm._v(" "), _c('ActionFavorite', {
          attrs: {
            "list-name": "Избранное"
          },
          on: {
            "success": function ($event) {
              ;
              _vm.productList = [], _vm.emitter.emit('clear-favorite-list');
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var removeProducts = _ref2.removeProducts;
              return [_c('Modal', {
                attrs: {
                  "show": _vm.modalActive,
                  "max-width": "358px"
                },
                on: {
                  "close": function ($event) {
                    _vm.modalActive = false;
                  }
                },
                scopedSlots: _vm._u([{
                  key: "title",
                  fn: function () {
                    return [_c('div', {
                      staticClass: "favorite-page__delete-products-title"
                    }, [_vm._v("\n              Очистка списка\n            ")])];
                  },
                  proxy: true
                }], null, true)
              }, [_vm._v(" "), _c('div', {
                staticClass: "favorite-page__delete-products-content"
              }, [_c('p', {
                staticClass: "p"
              }, [_vm._v("\n              Вы хотите удалить все товары из избранного?\n            ")]), _vm._v(" "), _c('div', {
                staticClass: "favorite-page__delete-products-buttons"
              }, [_c('Button', {
                staticClass: "mr-15",
                on: {
                  "click": function ($event) {
                    removeProducts({
                      ids: _vm.ids
                    }), _vm.modalActive = false;
                  }
                }
              }, [_vm._v("\n                Удалить всё\n              ")]), _vm._v(" "), _c('Button', {
                attrs: {
                  "theme": "white"
                },
                on: {
                  "click": function ($event) {
                    _vm.modalActive = false;
                  }
                }
              }, [_vm._v("\n                Отменить\n              ")])], 1)])])];
            }
          }], null, false, 287013668)
        })], 1) : _vm._e()]];
      }
    }], null, false, 1385764735)
  }) : _c('Unavailable', {
    attrs: {
      "icon": "favorite"
    }
  }, [_c('div', {
    staticClass: "h3 mb-10"
  }, [_vm._v("\n    В избранном нет товаров\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("\n    Вы можете найти на сайте интересные товары и добавить их в избранное чтобы не потерять\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }